import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Emdash from '@components/shared/Emdash';

type Props = {
  availableToday: boolean;
  availabilityDate?: string | null;
};

const AvailabilityCell: React.FC<Props> = ({ availableToday, availabilityDate = null }) => {
  const { t } = useTranslation();

  if (availableToday) {
    return t('common:listing.immediateAvailability');
  }

  if (availabilityDate) {
    return <> {t('units:date', { date: availabilityDate })} </>;
  }

  return <Emdash muted />;
};

export default AvailabilityCell;
